import { render, staticRenderFns } from "./ReadingTasks.vue?vue&type=template&id=e195a082&scoped=true"
import script from "./ReadingTasks.vue?vue&type=script&lang=js"
export * from "./ReadingTasks.vue?vue&type=script&lang=js"
import style0 from "./ReadingTasks.vue?vue&type=style&index=0&id=e195a082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195a082",
  null
  
)

export default component.exports